import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchWorkoutPreference,
  updateWorkoutPreference,
} from "../../api/wokoutPreferenceApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchWorkoutPreferenceThunk = createAsyncThunk(
  Endpoints.Get_Workout_Preference,
  async (ClientId, { rejectWithValue }) => {
    try {
      const data = await fetchWorkoutPreference(ClientId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postWorkoutPlanApi = createAsyncThunk(
  Endpoints.POST_WORKOUT_PLAN,
  async ({ workoutPlanData }, { rejectWithValue }) => {
    try {
      const data = await updateWorkoutPreference({ workoutPlanData });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create workout plan..."
      );
    }
  }
);

export const updateWorkoutPreferenceApi = createAsyncThunk(
  Endpoints.UPDATE_WORKOUT_PREFERENCE,
  async ({ workoutPreferenceData }, { rejectWithValue }) => {
    try {
      const data = await updateWorkoutPreference({ workoutPreferenceData });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update Workout Preference"
      );
    }
  }
);

const workoutPreferenceSlice = createSlice({
  name: "getWorkoutPreference",
  initialState: {
    workoutPreference: null,
    isloading: false,
    error: null,
    successMessage: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutPreferenceThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(fetchWorkoutPreferenceThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutPreference = action.payload;
      })
      .addCase(fetchWorkoutPreferenceThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      })

      .addCase(updateWorkoutPreferenceApi.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(updateWorkoutPreferenceApi.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutPreference = action.payload;
      })
      .addCase(updateWorkoutPreferenceApi.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSuccessMessage } = workoutPreferenceSlice.actions;

export const WorkoutReducer = workoutPreferenceSlice.reducer;
